module.exports = __webpack_public_path__ + "img/corner-joint-left-internal.3d21d7f4.svg";